import { ChatOutlined } from "@mui/icons-material";

export const chat = (props) => {
  return <ChatOutlined {...props} />;
};
